import React, { useEffect } from 'react';
import { T } from '../../utils/I18n/I18n';
import { Link, Navigate, useLocation } from 'react-router-dom'; // Zamiana Redirect na Navigate
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import Loader from '../../components/Loader';
import { useQueryString } from '../../hooks/useQueryString';
import { useUserContext } from '../../context/UserContext';
import productionConfiguration from '../../config/default.json';
import readConfig from '../../utils/readClientConfiguration';
import './style.scss';
import { GET_BACKEND_CONFIG } from '../../commonQueries';
import { purchaseEvent } from '../../hooks/useAnalytics';
import { CART_FRAGMENT } from '../Cart/queriesCart';
import { useCartContext } from "../../context/CartContext";

const iban = readConfig(productionConfiguration, 'iban');
const country = readConfig(productionConfiguration, 'countryCode');
const isRs = country.includes('RS');
const organizationId = readConfig(productionConfiguration, 'tradedoublerOrganizationId');
const eventId = readConfig(productionConfiguration, 'tradedoublerSaleEventId');

const QUERY_HASH = gql`
    ${CART_FRAGMENT}
    query keksPayStatus($hash_identity: String!) {
        keksPayStatus(hash_identity: $hash_identity) {
            order_number
            loyalty_points_earned
            is_loyalty
            email
            cart {
                ...CartFields
            }
        }
    }
`;

const BankTransferSection = ({ reference }) => {
    return (
        <div className="ml-10 mt-10">
            <p className="fs-15">
                <T id="checkout.pleaseMakeAPayment" />{' '}
                <strong>
                    <T id="checkout.within24Hours" />
                </strong>
                , <T id="checkout.deliveryInfo" />.
            </p>

            <p className="mt-sm fw-400">
                <T id="checkout.paymentInformation" />:
            </p>

            <p className="mt-sm fw-400">
                <T id="checkout.recipient" />:{' '}
                <strong>
                    <T id="checkout.receiver" />
                </strong>
            </p>

            <p className="mt-sm fw-400">
                <T id="checkout.iban" />: <strong>{iban}</strong>
            </p>

            <p className="mt-sm fw-400">
                <T id="checkout.referenceNumber" />: <strong>{`${reference.model}-${reference.number}`}</strong>
            </p>

            <p className="mt-sm fw-400">
                <T id="checkout.referentNumberRequired" />
            </p>
        </div>
    );
};

const BankTransferSectionRs = ({ reference, cart }) => {
    return (
        <div className="ml-10 mt-10">
            <p className="fs-15">
                <T id="checkout.pleaseMakeAPayment" />{' '}
                <strong>
                    <T id="checkout.within24Hours" />
                </strong>
                , <T id="checkout.deliveryInfo" />.
            </p>

            <p className="mt-sm fw-400">
                <T id="checkout.paymentInformation" />:
            </p>

            <p className="mt-sm fw-400">
                <T id="checkout.recipient" />:{' '}
                <strong>
                    <T id="checkout.receiver" />
                </strong>
            </p>

            <p className="mt-sm fw-400">
                <T id="checkout.iban" />: <strong>{iban}</strong>
            </p>

            <p className="mt-sm fw-400">
                <T id="checkout.referenceNumber" />: <strong>{`${reference.rsNumber}`}</strong>
            </p>

            <p className="mt-sm fw-400">
                <T id="checkout.referentNumberRequired" />
            </p>
        </div>
    );
};

const CashOnDeliverySection = () => {
    return (
        <div className="ml-10 mt-10">
            {isRs && (
                <p className="fs-15 mb-20">
          <span>
            <T id="checkout.receiptInfo1" />
          </span>
                    <br />
                    <span>
            <T id="checkout.receiptInfo2" />
          </span>
                </p>
            )}

            <p className="fs-15 fw-600">
                <T id="checkout.orderRejection" />
            </p>

            {isRs ? (
                <p className="mt-20">
                    <T id="checkout.deliveryCall" />
                </p>
            ) : (
                <p className="mt-10">
                    <T id="checkout.deliveryAlert1" />{' '}
                    <strong>
                        <T id="checkout.deliveryAlert2" />
                    </strong>
                    .<br />
                    <T id="checkout.deliveryAlert3" />
                    <br />
                </p>
            )}
        </div>
    );
};

const PikpayTransferSection = () => {
    return (
        <div className="ml-10">
            <p className="fs-15 mt-10">
                <T id="checkout.pikpay1" />
            </p>
            <p className="fs-15 mt-10">
                <T id="checkout.pikpay2" />
            </p>
            <p className="fs-15 mt-10">
                <T id="checkout.pikpay3" />
            </p>
        </div>
    );
};

const CheckoutSuccessComponent = ({
                                      orderNumber,
                                      reference,
                                      loyaltyPoints,
                                      paymentMethod,
                                      email,
                                      isLoyaltyMember,
                                      isLoggedIn,
                                      cart,
                                      currencyCode
                                  }) => {
    const { resetCart } = useCartContext();

    // Wywołujemy resetCart tylko raz przy montowaniu komponentu
    useEffect(() => {
        resetCart();
    }, []); // Pusta tablica zależności - efekt uruchomi się tylko raz

    return (
        <div className="checkout-success">
            <div className="checkout-success__left">
                <h1 className="lh-44">
                    <T id="checkout.thanksForPurchase" />
                </h1>

                <p className="mt-20 fs-20 fw-400">
                    <T id="checkout.orderNumber" /> <strong>{orderNumber}</strong>.
                </p>

                <p className="mt-10 fs-16 fw-600">
                    <T id="checkout.emailOrderStatus" />
                </p>

                {isLoggedIn && !isLoyaltyMember && (
                    <p className="mt-20 fs-15">
                        <T id="checkout.becomeLoyaltyMember1" />
                        <Link className="emmezeta-club-link__no-decoration" to="/customer/account/loyalty">
                            <T id="checkout.becomeLoyaltyMember2" />
                        </Link>
                        <T id="checkout.becomeLoyaltyMember3" />
                    </p>
                )}

                {!isLoggedIn && (
                    <p className="mt-20 fs-15">
                        <T id="checkout.notRegisteredUsers" />{' '}
                        <Link className="emmezeta-club-link__no-decoration" to="/customer/account/loyalty">
                            <T id="cart.emmezetaClub" />
                        </Link>
                        .
                        <br />
                        <T id="checkout.registration" />
                    </p>
                )}

                {isRs === false && paymentMethod === 'banktransfer' && <BankTransferSection reference={reference} />}
                {isRs === true && paymentMethod === 'banktransfer' && <BankTransferSectionRs reference={reference} cart={cart} />}
                {paymentMethod === 'cashondelivery' && <CashOnDeliverySection />}
                {paymentMethod === 'pikpay' && <PikpayTransferSection />}

                <hr className="mt-60 w-100" />

                {isLoggedIn ? (
                    <>
                        <p className="mt-30">
                            <T id="checkout.loggedUserStatus" />
                        </p>
                        <Link to="/customer/account">
                            <button type="button" className="open-profile-button mt-20 fs-16">
                                <T id="checkout.myProfile" />
                            </button>
                        </Link>
                    </>
                ) : (
                    <>
                        <p className="mt-30">
                            <T id="checkout.orderStatus" />
                        </p>

                        <p className="mt-sm">
                            <T id="checkout.openAccountText" />
                        </p>

                        <p className="mt-sm">
                            <T id="checkout.email" />: {email}
                        </p>

                        <Link to="/customer/registration">
                            <button type="button" className="open-profile-button mt-20 fs-16">
                                <T id="checkout.openMyProfile" />
                            </button>
                        </Link>
                    </>
                )}

                <hr className="mt-20 w-100" />

                <Link to="/" className="homepage-link mt-20">
                    <T id="checkout.backToFrontPage" />
                </Link>
            </div>

            <div className="checkout-success__right">
                <div>
                    <img alt="club-thank-you" src="/images/checkout/emmzeta-klub-logo-thank-you-page.png" />
                    <img alt="card-success" className="club-card" src="/images/checkout/kartica-success-flib.png" />
                </div>

                {isLoyaltyMember ? (
                    <p className="mt-30 fs-15 fw-400">
                        <T id="checkout.loyaltyMemberMessage" />
                    </p>
                ) : (
                    <p className="mt-30 fs-15 fw-400">
                        <T id="checkout.achievableNumbarOfPoints" /> :
                    </p>
                )}

                <p className="mt-20 fs-20">
                    <strong>{loyaltyPoints}</strong>
                </p>

                <hr className="mt-20" />

                {isLoyaltyMember ? (
                    <p className="mt-20 italic">
            <span>
              <T id="checkout.checkLoyaltyPoints" />
            </span>
                        <span>
              <Link className="checkout-success__right__loyalty-link" to="/customer/account/loyalty">
                <T id="club.points" />
              </Link>
            </span>
                    </p>
                ) : (
                    <>
                        <p className="mt-20 italic">
                            <T id="checkout.onlyRegisteredCustomers" />
                            <br />
                            <Link className="emmezeta-club-link" to="/customer/account/loyalty">
                                <T id="personalArea.club" />
                            </Link>
                        </p>

                        <p className="mt-10 italic">
                            <strong>
                                <T id="checkout.registerToClubText" />
                            </strong>
                        </p>

                        <Link to="/customer/account/loyalty">
                            <button type="button" className="emmezeta-club-button mt-20">
                                <T id="checkout.registerToClub" />
                            </button>
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
};

const CheckoutSuccess = () => {
    const { state } = useLocation();
    const { getQueryStringParam } = useQueryString();
    const hashIdentity = getQueryStringParam('identity_hash');
    const { user } = useUserContext();

    // Skip these queries if no hash identity
    const { data: backendConfig, loading: backendConfigLoading } = useQuery(GET_BACKEND_CONFIG, {
        skip: !hashIdentity,
        fetchPolicy: 'cache-first',
    });
    const { data, loading } = useQuery(QUERY_HASH, {
        skip: !hashIdentity,
        variables: {
            hash_identity: hashIdentity,
        },
    });
    console.log('bzzzzzzzzzzz', state)
    if (state) {
        return <CheckoutSuccessComponent {...state} />;
    }

    // if (!hashIdentity) {
    //     return <Navigate to="/" replace />; // Zamiana Redirect na Navigate
    // }

    if (backendConfigLoading || loading || !data || !backendConfig) {
        return <Loader />;
    }

    if (data && data.keksPayStatus && data.keksPayStatus.cart) {
        const { keksPayStatus } = data;
        const { cart } = keksPayStatus;
        purchaseEvent(cart, data.keksPayStatus.order_number, backendConfig);
    }

    return (
        <CheckoutSuccessComponent
            orderNumber={data.keksPayStatus.order_number}
            loyaltyPoints={data.keksPayStatus.loyalty_points_earned}
            paymentMethod="kekspay"
            email={data.keksPayStatus.email}
            isLoggedIn={!!user}
            isLoyaltyMember={data.keksPayStatus.is_loyalty}
        />
    );
};

export default CheckoutSuccess;